
<script context="module">


</script>

<script>
  import { user } from './vars.js';
  import { intcomma } from 'journalize';
  import { lookup } from './pmilookup.js';
  import mapboxgl from 'mapbox-gl';
import _ from 'lodash';


  ///map///
  var lodash_debounce = _.debounce;
  var debouncedUpdateMapStyle = lodash_debounce(updateMapStyle, 300);

var layerId = 'zcta-homes'; // our vector tile layer ID

var vectorTileSource = 'mapbox://latimes.64xetk4q'; // the active hover feature

var hoverFeatureId; // the active category

var activeCategory = null;
var breaks = [1, 10, 25, 50, 100].reverse();

function roundBreaks(value) {
  for (var idx = 0; idx < breaks.length; idx++) {
    var b = breaks[idx];

    if (value >= b) {
      return b;
    }
  }
}

const medianA = document.getElementById('median_a');
const medianB = document.getElementById('median_b');
const medianC = document.getElementById('median_c');
const medianD = document.getElementById('median_d');

medianA.innerHTML = '360,000';
medianB.innerHTML = '360,001';
medianC.innerHTML = '720,000';
medianD.innerHTML = '720,000';

var tooltipEl = document.querySelector('.map-tooltip');
var tooltipZipEl = tooltipEl.querySelector('.map-tooltip__zip');
var tooltipTotalEl = tooltipEl.querySelector('.map-tooltip__total');
var bounds = [-119.25658, 34.29202, -116.841974, 33.5024226];

mapboxgl.accessToken =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ'; // we're mappin

var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/latimes/cl0vogeye000d14rdif60p4ur'.concat('/draft'),
  // only uses the "draft" version locally
  pitchWithRotate: false,
  // this prevents accidentially changing the pitch
  dragRotate: false,
  // this prevents accidentially rotating the map
  bounds: bounds,
  fitBoundsOptions: {
    padding: {
      top: 50,
      right: 20,
      bottom: 20,
      left: 20,
    },
  },
}); // adds navigation controls

var navigationControl = new mapboxgl.NavigationControl({
  showCompass: false, // we don't want pitch
});
map.addControl(navigationControl); // add geocoder

const geocoder = new MapboxGeocoder({
  accessToken: mapboxgl.accessToken,
  countries: 'us',
  region: 'ca',
  placeholder: 'Enter an address to zoom',
  bbox: [-124.410607, 32.534231, -114.134458, 42.009659],
  mapboxgl: mapboxgl,
});
map.addControl(geocoder, 'top-left'); // updates the map based on the active value

function updateMapStyle(value) {
  // console.log("updating map")
  map.setPaintProperty('filtered', 'fill-color', [
    'let',
    'offby',
    ['/', ['number', Number(value)], ['get', 'price']],
    ['step', ['var', 'offby'], '#bdd4ef', 0.5, '#87abda', 1, '#3462ae'],
  ]);
  //['#3462ae','#87abda','#bdd4ef']
  // map.setFilter('filtered', ['<', 'price', Number(value) * 1.15]);
  // map.setPaintProperty('filtered', 'fill-opacity', 0.6);
}

 // things that should only happen once the map is ready to go

map.on('load', function () {
  map.addSource('data', {
    type: 'vector',
    url: vectorTileSource,
    generateId: true,
  }); //add layer

  map.addLayer(
    {
      'id': 'filtered',
      'type': 'fill',
      'source': 'data',
      'source-layer': 'zctaHomePrice',
      // 'paint': {
      //   'fill-color': '#1C3578',
      //   'fill-opacity': 0,
      // },
    },
    'building'
  );

  map.addLayer({
    'id': 'hover-layer',
    'type': 'line',
    'source': 'data',
    'source-layer': 'zctaHomePrice',
    'paint': {
      'line-width': 2,
      'line-color': '#333333',
      'line-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        1,
        0,
      ],
    },
  });
  map.on('mousemove', layerId, function (e) {
    relocateTooltip(
      tooltipEl,
      e.originalEvent.clientX,
      e.originalEvent.clientY
    );
    map.getCanvas().style.cursor = 'auto';
    var features = map.queryRenderedFeatures(e.point);
    //    console.log(features);
    var activeFeature = features.length ? features[0] : undefined;
    var id = activeFeature.properties.zip;
    // console.log('price', activeFeature.properties['price']);

    var value = roundBreaks(activeFeature.properties['price']);

    if (!id) return;
    if (e.features.length > 0) {
      if (hoverFeatureId) {
        //  console.log('featureid', hoverFeatureId);
        map.setFeatureState(
          {
            source: 'data',
            sourceLayer: 'zctaHomePrice',
            id: hoverFeatureId,
          },
          {
            hover: false,
          }
        );
      }

      hoverFeatureId = e.features[0].id;
      //  console.log('hover true');
      map.setFeatureState(
        {
          source: 'data',
          sourceLayer: 'zctaHomePrice',
          id: hoverFeatureId,
        },
        {
          hover: true,
        }
      );

      tooltipEl.removeAttribute('hidden');
      tooltipZipEl.textContent = e.features[0].properties.zip;
      tooltipTotalEl.textContent = `Typical home price: $${intcomma(
        e.features[0].properties['price']
      )}`;
    }
  });

  map.on('mouseleave', layerId, function () {
    if (hoverFeatureId) {
      map.setFeatureState(
        {
          source: 'data',
          sourceLayer: 'zctaHomePrice',
          id: hoverFeatureId,
        },
        {
          hover: false,
        }
      );
    }

    hoverFeatureId = null;
    map.getCanvas().style.cursor = 'grab';
    tooltipEl.setAttribute('hidden', '');
  });
  debouncedUpdateMapStyle(360000);
  // disable map rotation using right click + drag
  map.dragRotate.disable();

  // disable map rotation using touch rotation gesture
  map.touchZoomRotate.disableRotation();
  run = "run"
});
let run;

function clamp(n, min, max) {
  return Math.min(Math.max(n, min), max);
}

var tooltipPush = 20;

function relocateTooltip(el, x, y) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
    height = _el$getBoundingClient.height,
    width = _el$getBoundingClient.width;

  var innerWidth = window.innerWidth;
  var innerHeight = window.innerHeight;
  var left = clamp(
    x - width / 2,
    tooltipPush,
    innerWidth - width - tooltipPush
  );
  var top =
    innerHeight > y + tooltipPush + height
      ? y + tooltipPush
      : y - height - tooltipPush;
  el.style.left = ''.concat(left, 'px');
  el.style.top = ''.concat(top, 'px');

  map.resize();
}




  ////calc///

  var years = 30,
    allMonths = years * 12,
    
    homePriceRaw = 360000,
    dAlert='';

  let showAll = false;
  let inputValue = 4.5
  $: apr = $user.apr / 100
  $: aprMonth = apr / 12

  $: downPercent = (toInt($user.down) / homePriceRaw) * 100;
  $: homePrice = homePriceRaw.toLocaleString('en-US'); // to change to reader friendly format
  //yearly values
  $: insurance = (homePriceRaw * 0.0022) / 12;
  $: tax = (homePriceRaw * 0.0125) / 12;

  $: pmiCalc = (d, c) => {
    let p;
    let down = d / 100;
    for (var l of lookup) {
      if (0.1999 < down) {
        // console.log('down is high');
        p = 0;
      } else if (0.03 > down) {
        // console.log('down is low');
        p = '--';
      } else if (l['downMax'] >= down && down >= l['downMin']) {
        for (var m of l['credit']) {
          if (m['cMax'] >= c && c >= m['cMin']) {
            p = m['pmiMonth'];
          }
        }
      }
    }

    return p;
  };

  $: pmi = ((homePriceRaw-toInt($user.down)) * pmiCalc(downPercent, toInt($user.credit))) / 12;

  //backend ratio of debt and income
  $: piti_36 = (toInt($user.income) / 12) * (26 / 100) - toInt($user.debt);

  //mortgage
  $: mortgage = (x) =>
    (x * (1 - Math.pow(1 + aprMonth, -allMonths))) / aprMonth +
    toInt($user.down);
  $: budget = mortgage(piti_36).toFixed(0);
  

  //monthly payment
  $: payment = (x) =>
    x *
    aprMonth *
    (Math.pow(1 + aprMonth, allMonths) /
      (Math.pow(1 + aprMonth, allMonths) - 1));

  // $: homePriceRaw = mortgage(payment(budget-$user.down)-pmi).toFixed(0)

  $: pNi = payment(homePriceRaw - toInt($user.down));
  $: totalPaymentRaw = pNi + tax + insurance + pmi;
  $: totalPayment = (t)=>{
    if (t<0){
        return "None"
    }else if (isNaN(t)){
        return "--"
    }else{
        return intcomma(t.toFixed())
    }
  }
    $:leftOver = (toInt($user.moIncome) - totalPaymentRaw- toInt($user.debt)).toFixed()

  $: dti = (t)=>{
    //dti takes in total payment raw 
    // console.log("dti", homePriceRaw, downPercent)
    if (isNaN(t) &&  checkCredit($user.credit)){
        dAlert = "Please enter valid credit score."
        return "--"
    }else if(isNaN(t) && lowCredit($user.credit)){
      dAlert = "Your credit score may be too low."
        return "--"
    }else if((homePriceRaw >647200) && (downPercent < 5)){
      dAlert = "Down payment needs to be at least 5%."
        return "--"
    }else if ( (isNaN(t)) && ($user.apr <=0) ){
      dAlert = "Please enter a valid APR."
        return "--"
    }else if (isNaN(t) && testDti >0.5 ) {
      dAlert = `Your debt may be too high.`
        return (testDti*100).toFixed(1)
    }else if (isNaN(t)){
      dAlert = "Down payment needs to be at least 3%."
        return "--"
    }else if ($user.income== '0' | $user.income == '') {
      dAlert = "Please enter a valid income amount."
      return "--"
    }else{
        dAlert=''
        return (((t + toInt($user.debt)) / (toInt($user.income) / 12)) * 100).toFixed(1);
    }
  }

  $:dtiActual = dti(totalPaymentRaw)
  
  $:likely = (d)=>{
    console.log("updating liekly", $user.income)
    if  (isNaN(d)){
        return "--"
    }else if (testDti >=0.5){
      changeHome()
      barcolors("high debt")
      return "Your current debt may be too high to afford a mortgage"
    }else if (homePriceRaw == toInt($user.down)){
      return "You won't need a loan for this amount"
    }else if ((50 > d)&&(homePriceRaw-toInt($user.down)>970900)){

      return "You will need to get a jumbo loan for a house at this price"
    }else if ((45 < d)&&(50 >= d)){
      return "You are less likely to get approved for a house at this price"
    }else if (45 >= d) {
      return "You are likely to get approved for a house at this price"
    }else if (isNaN(d)){
        return "--"
    }else{
      return "You unlikely to get approved for a house at this price"
    }
  }

  $: color = (d)=>{
    if (d>=50){
      return "#d9624e"
    }else if (d <45){
      return "#709e19"
    }else if (d>=45 && d<50){
      return "#f9e467"
    }else{
      return "none"
    }
  }

  const checkKey = (e) => {
    let n = e.key;
    const validator = /[0-9]+/;
    if (!validator.test(n)) {
      e.preventDefault();
    }
  };

  const addComma = (e) => {
    let n = e.key;
    const validator = /[0-9\.\,]+/;
    if (!validator.test(n)) {
      e.preventDefault();
    }
  };

  const checkCredit = (n) => {
    if ((n < 801) && (n>299)) {
      return false
    } else {
      return true
    }
  };

  const lowCredit = (n) => {
    if (n<600) {
      return true
    } else {
      return false
    }
  };

  const homeToInt = (e) => {
    let n = e.target.value;
    n = n.replace(/\,/g, '');
    let clean = parseInt(n);
    // console.log(isNaN(clean));
    homePriceRaw = isNaN(clean) ? 0 : clean;
  };

  let toInt = (n) => {
    let c;
    if (typeof n == 'string') {
      c = n.replace(/\,/g, '');
    } else {
      c = n;
    }
    let clean = parseInt(c);
    return isNaN(clean) ? 0 : clean;
  };

  let showDetails = () => {
    let deets = document.getElementsByClassName('breakdown');
  };

  $: testDti = (toInt($user.debt))/(toInt($user.income) / 12 )

  const changeHome = ()=>{
    // console.log("blur before", homePriceRaw, budget)
    let test = budget-toInt($user.down)
    //console.log("test",test)
    let testdown = toInt($user.down)/test

    // console.log("dti", testDti)
    //   console.log("homeprice",homePriceRaw)
    //   console.log("old max",mortgage((toInt($user.income) / 12 - toInt($user.debt))*0.4))
    
    if (test <=0 && testDti >= 0.5){
      homePriceRaw = toInt($user.down)
      homePrice = homePriceRaw.toLocaleString('en-US'); 
      maxRange = toInt($user.down)
      //console.log("newmax", maxRange)
    }else if (test <=0){
      let ratio = toInt($user.income)/12*0.36-toInt($user.debt)
      //console.log("ratio", ratio)
      ratio <0?barcolors("tiny") :barcolors("small")
      homePriceRaw = ratio<0? toInt($user.down): Math.floor((mortgage(ratio)+toInt($user.down))/10000)*10000
      homePrice = homePriceRaw.toLocaleString('en-US'); 
      maxRange =   Math.floor((mortgage(toInt($user.income)/12*0.45-toInt($user.debt))+toInt($user.down))/10000)*10000+10000
      //console.log("low test not high debt", homePriceRaw, maxRange)
    }else if (toInt($user.down) > test){
      barcolors("norm")
      homePriceRaw = Math.floor((toInt(budget)+toInt($user.down))/10000)*10000
      homePrice = homePriceRaw.toLocaleString('en-US'); 
      // maxRange = toInt($user.down)*5
      getIt(homePriceRaw)
      console.log("down way high", toInt(budget))
    }else if (testdown>=0.2){
      barcolors("norm")
      homePriceRaw = Math.floor((toInt($user.down)*5)/10000)*10000
      homePrice = homePriceRaw.toLocaleString('en-US'); 
 
      getIt(homePriceRaw)
      //console.log("down meets above", toInt(budget))
    }else if (testdown>0.03) {
      barcolors("norm")
      homePriceRaw = Math.floor((toInt($user.down)*5)/10000)*10000
     // homePriceRaw = Math.floor((toInt(budget)-toInt($user.down))/10000)*10000
      homePrice = homePriceRaw.toLocaleString('en-US'); 

      //console.log("down is over 3")
      getIt(homePriceRaw)
    }else{
      barcolors("norm")
      homePriceRaw = Math.floor(toInt($user.down)/0.03/10000)*10000
      homePrice = homePriceRaw.toLocaleString('en-US'); 
      getIt(homePriceRaw)
     // console.log("small down", homePriceRaw)
    }
  }
  $:g = 70
  $:y = 85
  $:r = 98
  
  $:barcolors = (con)=>{
    //console.log("changing barx")
    if (con ==  "high debt"){
      r = 0
      g = 0
      y = 0
    }else if (con =="norm"){
      g = 70
      y = 85
      r = 98
  
    }else if (con == "small"){
      g = 30
      y = 65
      r = 90
    }else if (con == "tiny"){
      g = 0
      y =0
      r = 60
    }
    
  }
  let something = homePriceRaw

  $: maxRange = mortgage(
    (0.5* (toInt($user.income) / 12))-(toInt($user.debt)))-toInt($user.down);
  $: minRange = toInt($user.down)

  function getIt(e){
    something = e
    // console.log("getting it")
    debouncedUpdateMapStyle(e)
    let medianb = Number(something) + 1;
    let medianc = something * 2;

    medianA.innerHTML = `${intcomma(something)}`;
    medianB.innerHTML = `${intcomma(medianb)}`;
    medianC.innerHTML = `${intcomma(medianc)}`;
    medianD.innerHTML = `${intcomma(medianc)}`;
  }
</script>

{#if run}
<div class="form-wrapper">
  <div class="form-window inputs">
    <h3>Your information</h3>
    <form > 
      <div class="inputset">
        <span class="label"><label for="" >Annual income</label></span>
        <div class="input">
          $<input
            class="inputChange"
            aria-label="annual-income"
            type="text"
            on:keypress={(e) => checkKey(e)}
            on:blur={(e)=> {return $user.income = intcomma(toInt($user.income))}}
            on:blur={(e)=> changeHome()}
            bind:value={$user.income}
          /><span class="tiny">/year</span>
        </div>
      </div>

      <div class="inputset">
        <span class="label"><label for="">Monthly debts</label></span>
        <div class="input">
          $<input
          class="inputChange"
          aria-label="monthly-debts"
            type="text"
            on:keypress={(e) => checkKey(e)}
            on:blur={(e)=> {return $user.debt = intcomma(toInt($user.debt))}}
            on:blur={(e)=> changeHome()}
            bind:value={$user.debt}
          /><span class="tiny">/month</span>
        </div>
      </div>
      <div class="inputset">
        <span class="label"><label for="">Down payment</label></span>
        <div class="input">
          $<input
          class="inputChange"
          aria-label="down-payment"
            type="text"
            on:keypress={(e) => checkKey(e)}
            on:blur={(e)=> {return $user.down = intcomma(toInt($user.down))}}
            on:blur={(e)=> changeHome()}
            bind:value={$user.down}
          /><span class="tiny">({downPercent.toFixed(1)}%)</span>
        </div>
      </div>
      <div class="inputset">
        <span class="label"><label for="">Credit Score</label></span>
        <div class="input">
          <input
          class="inputChange"
          aria-label="credit-score"
            type="number"
            on:keypress={(e) => checkCredit(e)}
            on:keypress={(e) => lowCredit(e)}
            min="1"
            max="800"
            bind:value={$user.credit}
          />
        </div>
        <div class="inputset terms">
          <div>
            <span class="label"><label for="">Interest Rate</label></span>
            <div class="input">
              <input
              class="inputChange"
              aria-label="annual-interest-rate"
              type="number"
                step=0.1
                min=0
                max=100
                bind:value={$user.apr}
                on:blur={(e)=> changeHome()}
              />
              <span class="tiny">% /year</span>
            </div>
          </div>
          <div class="term">
            <span class="label"><label for="">Term</label></span>
            <div>
              <p><span class="years">30&nbsp;&nbsp;</span><span class="tiny">  years</span></p>
            </div>
          </div>
      </div>
    </form>
  </div>
  <div class="form-window price">
    <div id="slider-holder">
      <span class="home">
        {#key homePrice}
        $<input
        class="inputChange homeprice"
        id = "home-price"
        aria-label="home price"
          type="text"
          on:keypress={(e) => checkKey(e)}
          on:input={(e) => homeToInt(e)}
          bind:value={homePrice}
        />
        {/key}
      </span>
      <br />
      <br />
      <div  class="slider">
        {#key maxRange}
        <input
        class="inputChange graphic-slider"
        aria-label="home price"
        id ="home-slider"
        style="background-image: linear-gradient(
          to right,
          #709e19,
          #709e19 {g}%,
          #f9e467 {y}%,
          #d9624e {r}%
        )"
          type="range"
          step="10000"
          min={minRange}
          max={maxRange}
          on:change={getIt(homePriceRaw)}
          bind:value={homePriceRaw}
        />
        {/key}
      </div>
      <br />
      <div class="dti">
        <p class="likely">{likely(dtiActual)}</p>
        <span class="label"
          >Debt-to-income ratio: <span style="border-bottom:{color(dtiActual)} 3px solid" class="number">{dti(totalPaymentRaw)}%</span
          ></span
        >
        <div class="dalert">{dAlert}</div>
      </div>
    </div>

    <div class="payments">
      <div>
        <span class="label"
          >Total monthly payment: <span class="number">${totalPayment(totalPaymentRaw)}</span
          ></span
        >
        <br />
        <!-- <span class="number">${totalPayment} <button class="btn" on:click={onToggle} on:click={display.toggle}>
            {showAll ? 'Show less' : 'Show details'}
          </button></span> -->
      </div>

      <!-- {#if $display} -->
      <div class="breakdown">
        <div class="breakdown-item">
          <div class="title">Principal & Interest</div>
          <div class="value">${dti(totalPaymentRaw)=="--"? "--":intcomma(pNi.toFixed())}</div>
        </div>
        <div class="breakdown-item">
          <div class="title">Taxes</div>
          <div class="value">${dti(totalPaymentRaw)=="--"? "--":intcomma(tax.toFixed())}</div>
        </div>
        <div class="breakdown-item">
          <div class="title">Insurance</div>
          <div class="value">${dti(totalPaymentRaw)=="--"? "--":intcomma(insurance.toFixed())}</div>
        </div>
        <div class="breakdown-item">
          <div class="title">PMI</div>
          <div class="value">${isNaN(pmi) ? '--' : pmi.toFixed()}</div>
        </div>
      </div>
    </div>
    <!-- {/if} -->
  </div>
  <div class="form-window budget">
    <h3>Budgeting</h3>
    <div class="numbers">
      <div class="q" >
        <span class="q-label"><label for="">What is your monthly take-home pay after taxes and deductions?</label></span>
        <br>
        <span>
          $<input
            aria-label="monthly take home after taxes and deductions"
            placeholder="Enter an amount"
            type="text"
            on:keypress={(e) => checkKey(e)}
            bind:value={$user.moIncome}
          /><span class="tiny" style="float:none;">/month</span>
        </span>
      </div>
      <div class="a">
        <span >You will have 
        <span class="number">${isNaN(leftOver)? "--": intcomma(leftOver)}</span>
     left over every month after your debts.</span>
      </div>
    </div>
  </div>
</div>
{/if}
<style>
</style>
